import {Component, OnDestroy, OnInit} from "@angular/core";
import {FinServiceHttpClientService} from "../../data/fin-service-http-client.service";
import {FinService} from "src/app/models/FinService/fin-service";
import {HistoryHttpClientService} from "../../data/history-http-client.service";
import {History} from "../../models/History/history";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {LocaleConverterService} from "../../common/helpers/locale-converter.service";
import {PrintService} from "../../services/print.service";
import {ModalPaymentService} from "../../services/ux/modal-payment.service";
import { environment } from "src/environments/environment";
import { SetTitleService } from "src/app/services/set-title.service";


@Component({
    templateUrl: "./transaction-history.component.html",
    styleUrls: ["./transaction-history.component.css"]
})
export class TransactionHistoryComponent implements OnInit {
    isLoading = false;
    // loading = true;
    // records: any;
    // detail: any;
    // selectedCode: string;
    // filteredRecords: any;

    // region dataCarrier
    isBanking: any
    finServicesRecords: FinService[];
    private _historyRecords: History = {
        pageNumber: 1,
        totalRecords: 0,
        data: []
    };

    get historyRecords(): History {
        return this._historyRecords;
    }

    set historyRecords(value: History) {
        this._historyRecords = value;
        this.pageNumber = value.pageNumber || 1;
        this.totalRecords = value.totalRecords;
    }

    selectedCode = "";
    transactionDetail: {
        amount: number,
        invoice: any
    } = {} as {
        amount: number,
        invoice: any
    };
    // endregion

    // region Form
    historyForm = new FormGroup({
        finServiceId: new FormControl(0),
        fromDate: new FormControl(
            this.converter.formatForBootstrapDateInput(Date().toString()),
            Validators.required
        ),
        toDate: new FormControl(
            this.converter.formatForBootstrapDateInput(Date().toString()),
            Validators.required
        ),
        paymentType: new FormControl(0)
    });

    // endregion

    // region pageController
    pageNumber = 1;
    totalRecords = 0;
    // * Default value
    pageSize = 50;


    // region Range
    from = 1;
    to = this.totalRecords;
    // endregion


    // endregion

    constructor(
        // private client: Client,
        // public toastr: toastrService,
        // private route: ActivatedRoute,
        private modalService: ModalPaymentService,
        private finServiceClient: FinServiceHttpClientService,
        private historyClient: HistoryHttpClientService,
        private converter: LocaleConverterService,
        private printService: PrintService,
        private settitleservice : SetTitleService
    ) {
        this.isBanking = environment.env === "banking"
    }

    async ngOnInit() {
        await this.fillFinServices();
        await this.fillHistory();
        this.settitleservice.sendTitle("Account History");
    }

    async fillFinServices() {
        this.finServicesRecords = await this.finServiceClient.getFinServices();
    }


    async fillHistory() {
        this.isLoading = true
        const finServiceId = +this.historyForm.get("finServiceId").value;

        const paymentType = +this.historyForm.get("paymentType").value;
        const toDate = this.historyForm.get("toDate").value;
        const fromDate = this.historyForm.get("fromDate").value;

        this.historyRecords = await this.historyClient
            .SearchHistory(finServiceId, this.pageNumber, this.pageSize, fromDate, toDate, paymentType)
            .toPromise();
        this.isLoading = false
    }

    async onPrevious() {
        // this.pageNumber.next();
        this.pageNumber--;

        this.from = this.from - this.pageSize;
        if (this.to === this.totalRecords) {
            this.to = this.to - (this.totalRecords - this.pageSize * this.pageNumber);
        } else {
            this.to = this.to - this.pageSize;
        }

        await this.fillHistory();
    }

    async onNext() {
        this.pageNumber++;

        this.from = this.from + this.pageSize;
        if (this.to + this.pageSize >= this.totalRecords) {
            this.to = this.totalRecords;
        } else {
            this.to = this.to + this.pageSize;
        }

        await this.fillHistory();
    }

    async onSearch() {
        await this.fillHistory();
        if (this.pageSize > this.totalRecords) {
            this.to = this.totalRecords;
        } else {
            this.to = this.pageSize;
        }
    }

    async onReset() {
        this.historyForm.patchValue(
            {
                finServiceId: 0,
                fromDate: this.converter.formatForBootstrapDateInput(Date().toString()),
                toDate: this.converter.formatForBootstrapDateInput(Date().toString()),
                paymentType: 0
            }
        );
    }

    onPrint() {
        const formValue = Object.assign({}, this.historyForm.value);

        formValue.finServiceName = this.finServicesRecords.find(value => value.id === formValue.finServiceId).code;

        this.printService
            .printDocument("history", JSON.stringify(formValue));
    }

    constructDate = (year: number, month: number): Date => new Date(year, month);

    onDetails(record: any) {
        const details = JSON.parse(record.metadataJson);
        this.selectedCode = record.code;
        this.transactionDetail.amount = details.payData.TotalAmount;
        this.transactionDetail.invoice = details.invoiceData;
        this.modalService.open();
    }
}
